<template>

  <div
      class="bg-[#3E5463] bg-opacity-65 w-full h-[calc(100vh-91px)] flex justify-center items-end absolute inset-0 rounded-[20px] px-[12px] py-[19px]">
    <form class="bg-white px-[19px] py-[13px] w-full rounded-[20px] h-[337.14px] pt-[21.9px] mb-[28px]"
          @submit.prevent="verification">
      <div class="text-[20px] sm:text-[25px] font-normal text-center text-[#35474B] mx-auto max-w-[248px]">
        {{ lang === 'en' ? 'A confirmation Code has been Sent to' : 'لقد تم إرسال رمز التأكيد إلى' }}
      </div>
      <div
          class="text-[20px] sm:text-[25px] font-normal text-center text-[#35474B] mx-auto mb-[25px] mt-[25px] sm:mt-[25px] sm:mb-[32.2px]">
        {{ phone }}
        <span class="text-[#C6A798]"> {{ lang === 'en' ? '(Edit)' : '(يحرر)' }} </span>
      </div>
      <div class="w-full mx-auto" :class="{'mb-6': !codeError, 'mb-3': codeError}">
        <div class="w-full flex justify-between gap-2">
          <VOtpInput
              v-model:value="code"
              class="w-full justify-center gap-x-2 sm:gap-0 sm:justify-between"
              input-classes="w-full w-[48px] h-[60px] sm:w-[61px] sm:h-[79px] rounded-[5px] bg-[#E0E9F0] outline-0 border-0 text-center text-[35px] font-bold"
              :num-inputs="5"
              :should-auto-focus="true"
          />
        </div>
        <div class="text-red-700" v-if="codeError">{{ codeError }}</div>
        <div class="w-full text-[14px] text-center font-normal text-[#C6A798] mt-[4px] mb-[7px]" v-if="false">
          {{ lang === 'en' ? 'Resending the confirmation code in' : 'إعادة إرسال رمز التأكيد في' }} 01:28
        </div>
      </div>
      <button type="submit"
              class="rounded-[12px] w-full h-[64px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 text-white uppercase text-[18px] sm:text-[21px] font-bold"
              v-if="!loading">
        <span class="inline-block mt-[5px]">
          {{ lang === 'en' ? 'Verify' : 'يؤكد' }}
        </span>
      </button>
      <button type="button" :disabled="true"
              class="rounded-[12px] w-full h-[64px] bg-[#C6A798] text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
              v-if="loading">
        <span class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
      </button>
    </form>
  </div>

</template>

<script>

import VOtpInput  from "vue3-otp-input";
import Cookies from "js-cookie";
import ApiService from "@/service/apiService";

export default {
  data() {
    return {
      lang: window?.core?.lang,
      code: '',
      codeError: null,
      loading: false
    }
  },
  components: {
    VOtpInput
  },
  props: {
    phone: {
      required: true
    },
  },
  mounted() {

  },
  methods: {
    async verification() {
      try {
        this.codeError = null;
        if(!this.code || this.code.split('').length != 5){
          this.codeError = `${this.lang === 'en' ? 'Please fill up the input fields.' : 'يرجى ملء حقول الإدخال.'}`;
          return;
        }
        this.loading = true;
        const url = `/verify/code`;
        const data = {
          phone: this.phone,
          code: Object.values(this.code).join('')
        }
        const response = await ApiService.post(url, data);
        if (response.data.status === 204) {
          const user = await this.createClient();
          if (user.data.status === 200) {
            const data = JSON.stringify(user.data.data);
            Cookies.set('user_info', data)
            Cookies.set('access_token', user.data.token)
            window.location.reload();
            this.$emit('handleVerify');
          }
        } else if (response.data.status === 200) {
          const data = JSON.stringify(response.data.data);
          Cookies.set('user_info', data)
          Cookies.set('access_token', response.data.token)
          window.location.reload();
          this.$emit('handleVerify');
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loading = false;
      }
    },
    async createClient() {
      try {
        this.loading = true;
        const data = {
          name: 'yousef',
          gender: 'm',
          city: 'jeddah',
          phone: this.phone,
          birth_date: '2000-02-12',
          location: {
            lat: '23.170664',
            long: '89.212418',
            alt: '561561.651'
          }
        };
        const url = `/create/client`;
        const response = await ApiService.post(url, data);
        return response;
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },

    validateNumber(evt) {
      evt.stopPropagation();
      var theEvent = evt || window.event;

      // Handle paste
      if (theEvent.type === 'paste') {
        // @ts-ignore
        key = event.clipboardData.getData('text/plain');
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /^\d*\.?\d*$/;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
}

</script>